import React from 'react';
import agent from '../../agent';
import { connect } from 'react-redux';
import { DELETE_COMMENT } from '../../constants/actionTypes';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

const DeleteButton = props => {
  if (!props.show) return null;

  const handleDelete = () => {
    const payload = agent.Comments.delete(props.slug, props.commentId);
    props.onClick(payload, props.commentId);
  };

  return (
    <IconButton
      size="small"
      onClick={handleDelete}
      sx={{
        color: 'rgba(255,255,255,0.25)',
        '&:hover': { color: '#f44336' },
        '&:focus': { outline: 'none' },
        p: 0.5,
      }}
    >
      <DeleteIcon sx={{ fontSize: 15 }} />
    </IconButton>
  );
};

const mapDispatchToProps = dispatch => ({
  onClick: (payload, commentId) =>
    dispatch({ type: DELETE_COMMENT, payload, commentId })
});

export default connect(() => ({}), mapDispatchToProps)(DeleteButton);
